import { render } from "./UpdateReportDialog.vue?vue&type=template&id=2cd20285"
import script from "./UpdateReportDialog.vue?vue&type=script&lang=js"
export * from "./UpdateReportDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__